import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/eclipse.css'
import 'codemirror/mode/javascript/javascript.js'
import { UnControlled as CodeMirror } from 'react-codemirror2'

import {
  deactivateTemplates,
  getSchemas,
  updateItemCode,
  updateItemName,
  changesMade,
  clearChanges
} from '../../actions/actions'
import css from './styles.scss'
import Help from '../Help'
import TemplateSelector from '../TemplateSelector'
import ItemPreview from '../ItemPreview'
import PreviewItem from '../PreviewItem'
import NewDataSource from '../NewDataSource'
import EditDataSource from '../EditDataSource'

export class EditorRaw extends Component {
  constructor ({ id, item: { code, name } }) {
    super()
    const defaultCode = code || ''
    this.state = {
      itemId: id,
      defaultValue: defaultCode,
      raw: defaultCode,
      saving: false,
      changes: false,
      name: name || '',
      missingNameOnSave: false,
      modal: null
    }
    this.controller = AbortController ? new AbortController() : {}
  }

  getCurrentItemData = evt => {
    const changedBefore = this.state.changes
    return new Promise((resolve, reject) => {
      this.props.dispatch(updateItemName(this.state.name))
      this.props.dispatch(updateItemCode(this.state.raw))
      this.setState({
        report: true
      }, () => {
        this.setState({
          report: false
        }, () => {
          resolve(this.props)
          if (!changedBefore) {
            this.props.dispatch(clearChanges())
          }
        })
      })
    })
  }

  handleSave = evt => {
    let method = 'POST'
    let route = '/api/v1/items'
    const { name, raw: code } = this.state
    if (name === '') {
      this.setState({
        missingNameOnSave: true
      })
      return
    }
    this.setState({ saving: true })
    this.props.dispatch(updateItemName(name))
    this.props.dispatch(updateItemCode(code))
    // at this point redux has stored all the data and it's ready to be shipped off
    const { item: { id, dataSources }, templates: { selected: templateIds } } = this.props
    // const templateIds = templates.map(template => template.id)
    if (id) {
      method = 'PUT'
      route += '/'
      route += id
    }
    fetch(route, {
      method,
      signal: this.controller.signal,
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id,
        name,
        code,
        templateIds,
        dataSources
      })
    }).then(res => {
      if (res.status === 201 || res.status === 200) {
        return res.json()
      }

      return res.text()
    }).then(data => {
      if (typeof data === 'string') {
        alert(data)
        this.setState({
          saving: false,
          missingNameOnSave: false
        })
        return false
      }

      if (method === 'POST') {
        this.props.history.push(`/item/${data.id}`)
      } else {
        this.setState({
          saving: false,
          missingNameOnSave: false
        })
      }
      this.props.dispatch(clearChanges())
    }).catch(() => {
      this.setState({
        saving: false
      })
      alert('Save unsuccessful. Please check your connection and try again.')
    })
  }

  handleCodeChange = (editor, data, value) => {
    this.setState({
      raw: value
    }, () => this.props.dispatch(changesMade()))
  }

  handleUpdateName = evt => {
    this.setState({
      name: evt.target.value
    }, () => this.props.dispatch(changesMade()))
  }

  handleModal = (evt, edit = false, datasource = false) => {
    if (datasource) {
      this.setState({
        modal: 'editSource'
      })
    } else if (evt.target.getAttribute('data-modal')) {
      const modal = evt.target.getAttribute('data-modal')
      this.setState({
        modal
      })
    }
  }

  handleClearModal = () => {
    this.setState({
      modal: null
    })
  }

  keyUp = evt => {
    if (evt.key === 's' && (evt.ctrlKey || evt.metaKey)) {
      evt.preventDefault()
      this.handleSave()
    }
  }

  listenForCtrlS () {
    document.addEventListener('keydown', this.keyUp)
  }

  cancelCtrlS () {
    document.removeEventListener('keydown', this.keyUp)
  }

  componentDidMount () {
    const { item } = this.props
    if (item && item.templateIds && item.templateIds.length > 0) {
      this.props.dispatch(getSchemas(item.templateIds))
    }
    this.cancelCtrlS()
    this.listenForCtrlS()
  }

  componentWillUnmount () {
    this.cancelCtrlS()
    this.props.dispatch(deactivateTemplates())
    this.controller.abort()
  }

  componentWillReceiveProps (nextProps) {
    const { item: { changes } } = nextProps
    this.setState({
      changes
    })
  }

  render () {
    const options = {
      mode: 'javascript',
      theme: 'eclipse',
      lineNumbers: true
    }
    const showTemplateSelector = this.props.templates.showTemplateSelector
    const { item: { hideNameField }, app: { primaryColor, secondaryColor, previewUrl } } = this.props
    const standAloneMode = this.props.app.standAloneMode
    const { name, saving, missingNameOnSave, changes, modal } = this.state
    let nameField = null
    let nameWarning = null
    let saveButtonText = 'Save'
    const tips = [
      <span key='tip-1'>Assign values to the item object (e.g. <code>item.stem = ‘What color is the sky?’</code>)</span>,
      <span key='tip-2'>Use lodash helper functions for convenience and randomization. Lodash is documented <a href='https://lodash.com/docs/' target='_blank' rel='noopener noreferrer'>here</a></span>,
      'Click Preview to view a single instance of your item'
    ]
    if (!hideNameField) {
      tips.unshift('Name Your Item')
    }
    if (showTemplateSelector) {
      tips.unshift('Select templates')
    }
    if (missingNameOnSave && name.length === 0) {
      nameWarning = (
        <p className={css.warn}>
          Item name is required
        </p>
      )
    }
    if (changes) {
      saveButtonText = 'Save'
    }
    if (saving) {
      saveButtonText = 'Saving...'
    }
    if (!hideNameField) {
      nameField = (
        <div className={css.name}>
          {nameWarning}
          <label className={css.label}>Name</label>
          <input type='text' value={name} onChange={this.handleUpdateName} className={css.input} />
        </div>)
    }

    let bottomOptions = null
    if (modal === 'editSource') {
      bottomOptions = <button type='button' onClick={this.handleSave} className={css.save} style={{ backgroundColor: secondaryColor }}>{saveButtonText}</button>
    } else if (modal !== 'preview' && modal !== 'previewItem' && modal !== 'newSource') {
      bottomOptions = (
        <div className={css.bottomOptions}>
          <button type='button' onClick={this.handleSave} className={css.save} style={{ backgroundColor: secondaryColor }}>{saveButtonText}</button>
        </div>
      )
    }

    let previewComponent = null
    if (previewUrl) {
      previewComponent = <PreviewItem modal={modal} onClearModal={this.handleClearModal} onHandleSave={this.handleSave} saving={saving} />
    }

    return (
      <article className={`${css.EditorRaw} ${standAloneMode ? css.EditorRawStandAlone : ''}`}>
        <section className={`${css.container} ${standAloneMode ? css.containerStandAlone : ''}`}>
          <div className={css.help} onClick={this.handleModal}>
            <div className={css.topNav}>
              {previewComponent}
              <ItemPreview getCurrentItemData={this.getCurrentItemData} modal={this.state.modal} onClearModal={this.handleClearModal} />
            </div>
            <button type='button' onClick={this.handleClearModal} className={`${css.backToItem} ${!modal ? css.currentTab : null}`} style={{ background: !this.state.modal ? primaryColor : null }}>Item Details</button>
            <NewDataSource modal={this.state.modal} onHandleModal={this.handleModal} onClearModal={this.handleClearModal} />
            <EditDataSource modal={this.state.modal} onClearModal={this.handleClearModal} />
            {/* <ToolTip tips={ tips } minWidth={ 400 } /> */}
            <Help />
          </div>
          <div className={css.editWrap}>
            <TemplateSelector />
            {nameField}
            <div className={css.editor}>
              <CodeMirror
                value={this.state.defaultValue}
                options={options}
                onChange={this.handleCodeChange}
              />
            </div>
            {bottomOptions}
          </div>
        </section>
      </article>
    )
  }
}

const mapStateToProps = state => {
  const { app, auth, item, templates } = state
  return {
    app,
    auth,
    item,
    templates
  }
}

export default withRouter(connect(mapStateToProps)(EditorRaw))



// WEBPACK FOOTER //
// /app/js/components/EditorRaw/index.js